import { render, staticRenderFns } from "./gameSelect.vue?vue&type=template&id=d170189a&scoped=true"
import script from "./gameSelect.vue?vue&type=script&lang=js"
export * from "./gameSelect.vue?vue&type=script&lang=js"
import style0 from "./gameSelect.vue?vue&type=style&index=0&id=d170189a&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d170189a",
  null
  
)

export default component.exports